import posed from "react-pose";

const staggerMs = 500;
const fastStaggerMs = 50;
const initialDelayMs = 500;

export const pillsPreceedingDefault = 2;

export const AnimatedStep = posed.div({
  enter: {
    opacity: 1,
    staggerChildren: staggerMs,
    delayChildren: initialDelayMs
  },
  exit: { opacity: 0 }
});

export const AnimatedPills = posed.div({
  enter: {
    staggerChildren: fastStaggerMs,
    delayChildren: ({ preceeding = pillsPreceedingDefault }) =>
      staggerMs * preceeding + initialDelayMs
  }
});



// WEBPACK FOOTER //
// ./js/components/SolutionFinder/StepAnimations.js